module.exports = __webpack_public_path__ + "assets/img/d3ea719533b82f01c624fa7def13abc9.png";